import React from 'react';
import MEL from '../../assets/images/melo.png'
const SubscribeSection = () => {
  return (
    <section className="subscribe no-padding" style={{backgroundColor:'#fac56a'}}>
      <div className="container" style={{backgroundColor:'#fac56a'}}>
        <div className="row" style={{backgroundColor:'#fac56a'}}>
          
          {/* Left Column - Call to Action */}
          <div className="col-lg-6">
            <div className="subscribe-call-to-acton">
              <h3>Contactez-nous</h3>
              <h4 className='text-dark'> <i className="fa fa-phone"></i> (+243) 814-213-889 / +243 971 746 522</h4>
            </div>
          </div>

          {/* Right Column - Newsletter */}
          <div className="col-lg-6" style={{backgroundColor:'#000'}}>
            <div className="ts-newsletter row align-items-center" style={{backgroundColor:'#000'}}>
              
              <div className="col-md-8 newsletter-introtext">
              <a style={{fontFamily:'times', color:'#d8ba72'}} href="mailto:infos@gekas-security.com">
                <h4 className="text-white mb-0"> <i className="fa fa-envelope"></i> Ecrivez-Nous</h4>
                <p className="text-white">Pour plus d'informations</p>
                </a>
              </div>

              <div className="col-md-4 newsletter-form" >
              <a style={{fontFamily:'times', color:'#d8ba72'}} href="mailto:infos@azyekos-services.com">
              <img src={MEL}  alt="TikTok" style={{ width: '70px', height: '70px' }} />
              </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SubscribeSection;
